// export default function() {
//   const widgetName = 'cardWidgetExploreCards';
//   const widgetOpts = cardWidgetExploreCardsOpts;

//   return saffire.widgets.cardWidget($(`#${widgetName}`), {
//     currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
//     buyNowButton: {
//       visible: false,
//       text: 'BUY NOW'
//     },
//     cardWidgetLoaded: function(data, owl, hasData) {},
//     itemsPerPanel: 1,
//     hasImages: true,
//     lazyLoadImages: true,
//     imageIsBackground: false,
//     link: ['all'], // [], ['all'], ['image', 'title', 'description']
//     maxItemsVisible: 6,
//     moreButton: {
//       visible: false,
//       text: 'MORE'
//     },
//     scriptPath:  widgetOpts.scriptPath,
//     showDescription: false,
//     slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
//     slideshowOptions: {
//       items: 1,
//       loop: false,
//       margin: 10,
//       navText: ['Prev','Next'],
//       nav: false
//     },
//     textOverImage: true
//   });

// }

export default function () {
  const widgetName = "cardWidgetExploreCards";
  const widgetOpts = cardWidgetExploreCardsOpts;

  // Autoplay and alignment for mobile settings
  const autoPlay = true;
  const autoPlaySpeed = 6000;

  // AutoPlay confiog
  function autoPlaySetting() {
    let settingAutoP = {};
    if (autoPlay) {
      settingAutoP = { delay: autoPlaySpeed };
    } else {
      settingAutoP = false;
    }
    return settingAutoP;
  }

  const swiperLeftArrow = `
  <svg xmlns="http://www.w3.org/2000/svg" height="40" width="20" fill="#fff200" viewBox="0 0 256 512">
  <path d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"/></svg>
  `;

  const swiperRightArrow = `
  <svg xmlns="http://www.w3.org/2000/svg" height="40" width="20" fill="#fff200" viewBox="0 0 256 512">
  <path d="M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"/></svg>
  `;

  const swiperContainers = `
    <div class="swiper-button-prev">
      ${swiperLeftArrow}
    </div>

    <div class="swiper-container">
        <div class="swiper-wrapper">
        </div>
    </div>

    <div class="swiper-button-next">
      ${swiperRightArrow}
    </div>
  `;

  // Slide Template
  function buildSlideTemplate(slide) {
    const title = `<h3>${slide.Title.slice(0, 40)}</h3>`;
    const description = slide.Description
      ? `<p>${slide.Description.slice(0, 30)}</p>`
      : "";
    const date =
      slide.DetailLinkText.length > 4
        ? `<span class="swiper-date">${slide.DetailLinkText.trim().slice(
            0,
            15
          )}</span>`
        : "";

    const template = `
      <div class="swiper-slide">
      ${
        slide.URL
          ? `<a class="swiper-lineup" href="${slide.URL}" aria-label="${slide.Title}" title="${slide.Title}">`
          : `<div class="swiper-lineup void-link">`
      }
          ${date}
          <div class="swiper-content-container" >
            <div class="swiper-image-container swiper-lazy" style="background-image:url('${
              slide.ImageWithPath
            }')" data-background="${slide.ImageWithPath}" aria-label="${
      slide.ImageAlternateText
    }">
            </div>
            <div class="swiper-text-container">
              ${title}
              ${description}
            </div>
            
          </div>
        ${slide.URL ? `</a` : `</div>`}
      </div>
    `;

    return template;
  }

  let swiperWidget;
  // Swiper Initialization
  function initSwiper() {
    swiperWidget = new Swiper(`#${widgetName} .swiper-container`, {
      speed: 600,
      autoplay: autoPlaySetting(),
      loop: true,
      watchOverflow: false,
      slidesPerView: 5,
      spaceBetween: 20,
      freeMode: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: false,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      grabCursor: true,
      autoHeight: false,
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          centeredSlides: true,
        },

        800: {
          slidesPerView: 2,
        },

        1100: {
          slidesPerView: 3,
        },
        1300: {
          slidesPerView: 4,
        },
        1500: {
          slidesPerView: 5,
        },
      },
    });
  }

  const breakpoint = window.matchMedia("(min-width: 1500px)");

  const breakpointChecker = function () {
    let sliderDestroyed = false;
    if (breakpoint.matches && sliderDestroyed === false) {
      if (swiperWidget) swiperWidget.destroy(true, true);
      sliderDestroyed = true;
    } else {
      // if slider destroyed is true, then re-init slider
      if (!sliderDestroyed) initSwiper();
    }
  };

  function createSwiper() {
    // Fetch data and initialize widget
    saffire.utils.getWidgetData(widgetOpts).then(function (response) {
      if (response.Slides.length > 0) {
        $(`#${widgetName}`).html(swiperContainers);
        const swiperWidgetWrapper = $(`#${widgetName} .swiper-wrapper`);
        response.Slides.forEach(function (slide, i) {
          swiperWidgetWrapper.append(buildSlideTemplate(slide));
        });
        initSwiper();
        // breakpointChecker(response.Slides);
      } else {
        console.log(response);
        console.log("Error: No Data for swiperWidget");
        $(body).addClass("cardWidgetExploreCards-nodata");
      }
    });
  }

  createSwiper();
  // breakpoint.addListener(breakpointChecker);
}
